import { FC, memo } from "react";
import { Box } from "@mui/material";
import { ProductModel } from "../../../../../../models/Product.model";
import ActiveItem from "../active-item";

type Props = {
    products: ProductModel[];
    /** ids selecionados — só o card que mudou re-renderiza (ActiveItem é memo) */
    selectedIds: Set<number | undefined>;
    onClick: (product: ProductModel) => void;
    onPopUp: () => unknown;
    onSelect: (product: ProductModel, checked: boolean) => void;
    onFavorite: (product: ProductModel) => void;
    annotationOpen?: (product: ProductModel) => void;
};

/** Grade 2 colunas de ativos (ActiveItem) para uma aba da etapa de produtos. */
const ProductsGrid: FC<Props> = ({ products, selectedIds, onClick, onPopUp, onSelect, onFavorite, annotationOpen }) => (
    <Box
        sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
            gap: "10px",
            "@media (max-width: 360px)": {
                gridTemplateColumns: "minmax(0, 1fr)",
                minWidth: 0,
                overflowX: "hidden",
            },
        }}
    >
        {products.map((product) => (
            <ActiveItem
                key={product.idProduct ?? product.productName}
                props={product}
                onClick={onClick}
                onPopUp={onPopUp}
                onSelect={onSelect}
                annotationOpen={annotationOpen}
                onFavorite={onFavorite}
                checked={selectedIds.has(product.idProduct)}
            />
        ))}
    </Box>
);

export default memo(ProductsGrid);
